import gql from 'graphql-tag';

export const CREATE_TICKET = gql`
  mutation createTask($input: CreateTaskInputDto!) {
    createTask(input: $input)
  }
`;

export const REMOVE_TICKET = gql`
  mutation deleteTask($taskId: String!) {
    deleteTask(taskId: $taskId)
  }
`;

export const CHANGE_TICKET_STATUS = gql`
  mutation changeTaskStatus($taskId: String!, $status: ChatStatusEnum!) {
    changeTaskStatus(status: $status, taskId: $taskId)
  }
`;

export const CHANGE_TICKET = gql`
  mutation updateTask($input: UpdateTaskInput!) {
    updateTask(input: $input)
  }
`;

export const SEND_TICKET_MESSAGE = gql`
  mutation sendMessage($chatId: String!, $msg: CreateMessageInputDto!) {
    sendMessage(chatId: $chatId, msg: $msg)
  }
`;

export const UPDATE_TICKET_MESSAGE = gql`
  mutation updateMessage($chatId: String!, $msgId: String! $msg: CreateMessageInputDto!) {
    updateMessage(chatId: $chatId, msg: $msg, msgId: $msgId)
  }
`;

export const DELETE_TICKET_MESSAGE = gql`
  mutation DeleteMessage($chatId: String!, $msgId: String!) {
    deleteMessage(chatId: $chatId, msgId: $msgId)
  }
`;

export const READ_MESSAGES = gql`
  mutation readMessages($chatId: String!, $msgIds: [String!]!) {
    readMessages(chatId: $chatId, msgIds: $msgIds)
  }
`;

export const VALIDATE_CLIENT_TEXT = gql`
  mutation validateClientText($draft: String!, $kind: ValidationKind, $context: String) {
    accounting {
      validateClientText(draft: $draft, kind: $kind, context: $context) {
        needs_improvement
        issues
        language_detected
        foreign_fragments
        improved_en
        translation
        translation_language
      }
    }
  }
`;

export const VALIDATE_TICKET_DRAFT = gql`
  mutation validateTicketDraft($subject: String, $message: String) {
    accounting {
      validateTicketDraft(subject: $subject, message: $message) {
        subject {
          needs_improvement
          issues
          language_detected
          foreign_fragments
          improved_en
          translation
          translation_language
        }
        message {
          needs_improvement
          issues
          language_detected
          foreign_fragments
          improved_en
          translation
          translation_language
        }
      }
    }
  }
`;
